import { ChevronLeftIcon } from '@heroicons/react/24/outline'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import HoverableArrowLink from '@components/common/HoverableArrowLink'
import useNavigationProgramsTabData from '@components/hooks/useNavigationProgramsTabData'
import NavButtonLink from '@components/navigation/NavButtonLink'
import { getProgramsTabs, ProgramTab } from '@components/navigation/constants/programs'
import MobileMenuButton from '@components/navigation/mobile/MobileMenuButton'
import MobileMenuContainer from '@components/navigation/mobile/MobileMenuContainer'

import i18n from '@src/config/i18n'

type Props = {
  open: boolean
  onClose: () => void
}

export default function ProgramsMobileTabMenu({ open, onClose }: Props) {
  const { t } = useTranslation('revamp')
  const [selectedTab, setSelectedTab] = useState<ProgramTab>()
  const locale = i18n.language

  const programsTabData = useNavigationProgramsTabData()
  const programTabs = getProgramsTabs(t, locale, programsTabData)

  useEffect(() => {
    setSelectedTab(undefined)
  }, [open])

  return (
    <>
      <MobileMenuContainer open={open} hasSubmenuOpen={selectedTab !== undefined}>
        <button onClick={onClose} className='mt-14 mb-12 text-xl hover:underline flex items-center'>
          <ChevronLeftIcon className='mr-2 h-4 w-4' />
          <span>{t('back')}</span>
        </button>
        <section className='flex flex-col gap-8'>
          {programTabs.map((tab) => (
            <MobileMenuButton
              key={`mobile_program_tab_${tab.name}`}
              title={tab.name}
              onClick={() => {
                setSelectedTab(tab.key)
              }}
            />
          ))}
        </section>
      </MobileMenuContainer>
      {programTabs.map((tab) => (
        <MobileMenuContainer
          key={`mobile_training_tab_${tab.name}`}
          open={selectedTab === tab.key}
          className='pb-16'
        >
          <button
            onClick={() => setSelectedTab(undefined)}
            className='mt-14 mb-12 text-xl hover:underline flex items-center'
          >
            <ChevronLeftIcon className='mr-2 h-4 w-4' />
            <span>{t('back')}</span>
          </button>
          <section className='flex flex-col gap-6 items-start'>
            {tab.sections.map((section) => (
              <HoverableArrowLink
                key={`mobile_programs_${tab.name}_${section.title}`}
                className='text-xl leading-mid'
                href={section.link}
                text={section.title}
                arrowOpen
              />
            ))}
            <NavButtonLink
              className='text-base mt-4'
              link={tab.button.link}
              text={tab.button.text}
            />
          </section>
        </MobileMenuContainer>
      ))}
    </>
  )
}
